<template>
  <div>
    <SimpleLayout>
      <SellingStepsExplanation />
    </SimpleLayout>
  </div>
</template>

<script>
//import your components here
import SellingStepsExplanation from "@/components/products/SellingStepsExplanation.vue";
import SimpleLayout from "@/layouts/SimpleLayout.vue";

export default {
  components: {
    SellingStepsExplanation,
    SimpleLayout,
  },
};
</script>
